var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0072 0H69.347V66.3079H50.0072V0Z",
    fill: "#C8F22B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0375 10.6414L108.713 24.3167L61.8261 71.2034L48.1508 57.5281L95.0375 10.6414Z",
    fill: "#C8F22B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.354 50.0072V69.347H53.0463V50.0072H119.354Z",
    fill: "#C8F22B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.713 95.0375L95.0375 108.713L48.1508 61.8261L61.8261 48.1508L108.713 95.0375Z",
    fill: "#C8F22B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.347 119.354H50.0072L50.0072 53.0463H69.347L69.347 119.354Z",
    fill: "#C8F22B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3167 108.713L10.6414 95.0375L57.5281 48.1508L71.2034 61.8261L24.3167 108.713Z",
    fill: "#C8F22B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.347L2.30623e-07 50.0072H66.3079V69.347H0Z",
    fill: "#C8F22B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6414 24.3167L24.3167 10.6414L71.2034 57.5281L57.5281 71.2034L10.6414 24.3167Z",
    fill: "#C8F22B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle18);
export default __webpack_public_path__ + "static/media/Rectangle 18.dceeda867aabefb1e05114ba9897646b.svg";
export { ForwardRef as ReactComponent };